var site = site || {};

site.poll = site.poll || {};


site.poll.admin = {
	init: function() {
		const removeButton = document.querySelector('button#removeAnswer');
		const addButton = document.querySelector('button#addAnswer');

		if (removeButton) {
			removeButton.addEventListener('click', this.removeAnswer);
		}
		if (addButton) {
			addButton.addEventListener('click', this.addAnswer)
		}
	},
	removeAnswer: function() {
		const fieldset = document.querySelector('#fieldset-answers');

		const elements = fieldset.querySelector('.dgElements');
		const nrOfAnswers = elements.children.length;

		if (nrOfAnswers < 3) {
			return;
		}

		const lastInput = elements.querySelector('#elm_answer' + nrOfAnswers);
		lastInput.remove();
	},
	addAnswer: function() {
		const fieldset = document.querySelector('#fieldset-answers');

		const elements = fieldset.querySelector('.dgElements');
		const nrOfAnswers = elements.children.length;
		const nextNumber = nrOfAnswers + 1;

		let inputElement = document.createElement('input');
		inputElement.type = 'text';
		inputElement.name = `answer${nextNumber}`;
		inputElement.id = `answer${nextNumber}`;
		inputElement.class = 'text';

		let spanElement = document.createElement('span');
		spanElement.classList.add('lmnt');

		let labelElement = document.createElement('label');
		labelElement.htmlFor = `answer${nextNumber}`;
		labelElement.classList.add('optional');
		labelElement.innerHTML = 'Svar';

		let divElement = document.createElement('div');
		divElement.classList.add('elm');
		divElement.classList.add(`elm_Answer${nextNumber}`);
		divElement.classList.add('eType_text');
		divElement.id = `elm_answer${nextNumber}`;

		spanElement.appendChild(inputElement);
		divElement.appendChild(labelElement);
		divElement.appendChild(spanElement);

		elements.appendChild(divElement);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	site.poll.admin.init();
});
